import { z } from 'zod';

export const TURN_STATUSES = {
	win: 'win',
	bet: 'bet',
	lose: 'lose',
} as const satisfies Record<string, string>;

export type TurnStatus = (typeof TURN_STATUSES)[keyof typeof TURN_STATUSES];

export const turnStatusesSchema = z.nativeEnum(TURN_STATUSES);
